import { getValue } from '@kundinos/nanostores';

import { modulesStore, changeableParametersStore } from './stores';

function getParameterValues() {
  const changeableParameters = getValue(changeableParametersStore);
  const modules = getValue(modulesStore);
  const parameterValues: { id: number; count: number }[] = [];

  // Добавляем информацию о выбранных модулях
  modules?.forEach((module) => {
    parameterValues.push({
      id: module.parameterId,
      count: module.count,
    });
  });

  // Добавляем значения выбранных опций
  changeableParameters.forEach((parameter) => {
    (parameter.variants || []).forEach((variant) => {
      if (variant.selected) parameterValues.push({ id: variant.id, count: 1 });
    });
  });

  return parameterValues;
}

export default getParameterValues;
